import getBackOfficeCareAdmin from '@/lib/routes/backoffice/getBackOfficeCareAdmin'
import getBackOfficeCareAdminConsult from '@/lib/routes/backoffice/getBackOfficeCareAdminConsult'
import getBackOfficeGroupAdmin from '@/lib/routes/backoffice/getBackOfficeGroupAdmin'
import getBackOfficeGroupCall from '@/lib/routes/backoffice/getBackOfficeGroupCall'
import getBackOfficeGroupCallCenterAdmin from '@/lib/routes/backoffice/getBackOfficeGroupCallCenterAdmin'
import getBackOfficeGroupCompanionAdmin from '@/lib/routes/backoffice/getBackOfficeGroupCompanionAdmin'
import getBackOfficeGroupSuperAdmin from '@/lib/routes/backoffice/getBackOfficeGroupSuperAdmin'
import getBackOfficeInsightAdmin from '@/lib/routes/backoffice/getBackOfficeInsightAdmin'
import getBackOfficeSchoolAdmin from '@/lib/routes/backoffice/getBackOfficeSchoolAdmin'
import getBackOfficeSchoolInterneAdminConsult from '@/lib/routes/backoffice/getBackOfficeSchoolInterneAdminConsult'
import getBackOfficeSoundAdmin from '@/lib/routes/backoffice/getBackOfficeSoundAdmin'
import getBackOfficeSoundAdminItaly from '@/lib/routes/backoffice/getBackOfficeSoundAdminItaly'
import getBackOfficeStoreBagAdmin from '@/lib/routes/backoffice/getBackOfficeStoreBagAdmin'
import getBackOfficeStoreCscartAdmin from '@/lib/routes/backoffice/getBackOfficeStoreCscartAdmin'
import getExternalOfficeSftpConsult from '@/lib/routes/backoffice/getExternalOfficeSftpConsult'
import getIndustryOfficeGroupIndustry from '@/lib/routes/backoffice/getIndustryOfficeGroupIndustry'
import getIndustryOfficeInsightIndustry from '@/lib/routes/backoffice/getIndustryOfficeInsightIndustry'
import getIndustryOfficeSchoolIndustry from '@/lib/routes/backoffice/getIndustryOfficeSchoolIndustry'
import getIndustryOfficeStoreIndustry from '@/lib/routes/backoffice/getIndustryOfficeStoreIndustry'
import { routeFrontOfficeGroupNewsCounter } from '@/lib/routes/front/common/routeFrontOfficeGroupNews'
import {
  getFrontOfficeCareActivation,
  getFrontOfficeCarePharmacien,
} from '@/lib/routes/front/getFrontOfficeCarePharmacien'
import { getFrontOfficeConsultContract } from '@/lib/routes/front/getFrontOfficeConsultContract'
import { getFrontOfficeGroupPharmacien } from '@/lib/routes/front/getFrontOfficeGroupPharmacien'
import { getFrontOfficeGroupPharmacienAndUserTeam } from '@/lib/routes/front/getFrontOfficeGroupPharmacienAndUserTeam'
import { getFrontOfficeInsightHoldOwner } from '@/lib/routes/front/getFrontOfficeInsightHoldOwner'
import { getFrontOfficeInsightPharmacien } from '@/lib/routes/front/getFrontOfficeInsightPharmacien'
import { getFrontOfficeInsightPharmacienAndUserTeam } from '@/lib/routes/front/getFrontOfficeInsightPharmacienAndUserTeam'
import { getFrontOfficeInsightRewardsUser } from '@/lib/routes/front/getFrontOfficeInsightRewardsUser'
import { getFrontOfficeInsightUserChallenge } from '@/lib/routes/front/getFrontOfficeInsightUserChallenge'
import { getFrontOfficeQrLoginAllUser } from '@/lib/routes/front/getFrontOfficeQrLoginAllUser'
import { getFrontOfficeSchoolManagerLearner } from '@/lib/routes/front/getFrontOfficeSchoolManagerLearner'
import { getFrontOfficeSchoolPharmacienAndUserTeam } from '@/lib/routes/front/getFrontOfficeSchoolPharmacienAndUserTeam'
import { getFrontOfficeSchoolUserTeam } from '@/lib/routes/front/getFrontOfficeSchoolUserTeam'
import { getFrontOfficeSoundHoldOwner } from '@/lib/routes/front/getFrontOfficeSoundHoldOwner'
import { getFrontOfficeSoundPharmacien } from '@/lib/routes/front/getFrontOfficeSoundPharmacien'
import { getFrontOfficeStoreBagHoldOwner } from '@/lib/routes/front/getFrontOfficeStoreBagHoldOwner'
import { getFrontOfficeStoreBagPharmacien } from '@/lib/routes/front/getFrontOfficeStoreBagPharmacien'
import { getFrontOfficeStorePharmacien } from '@/lib/routes/front/getFrontOfficeStorePharmacien'

import getFrontOfficeGroupGroupementChainListRoutesAllUser from '@/lib/routes/front_groupement/getFrontOfficeGroupGroupementChainListRoutesAllUser'
import getFrontOfficeSchoolGroupementChainListRoutesManager from '@/lib/routes/front_groupement/getFrontOfficeGroupGroupementChainListRoutesManager'
import getFrontOfficeSchoolGroupementChainListRoutesAllUser from '@/lib/routes/front_groupement/getFrontOfficeSchoolGroupementChainListRoutesAllUser'
import getFrontOfficeSoundGroupementChainListRoutesAllUser from '@/lib/routes/front_groupement/getFrontOfficeSoundGroupementChainListRoutesAllUser'
import getFrontOfficeStoreGroupementChainListRoutesAllUser from '@/lib/routes/front_groupement/getFrontOfficeStoreGroupementChainListRoutesAllUser'
import getFrontOfficeGroupUrps from '@/lib/routes/front_urps/getFrontOfficeGroupUrps'

export const allRoutesAdmin = [
  ...getBackOfficeInsightAdmin,
  ...getBackOfficeSoundAdmin,
  ...getBackOfficeSoundAdminItaly,
  ...getBackOfficeStoreBagAdmin,
  ...getBackOfficeStoreCscartAdmin,

  ...getBackOfficeGroupSuperAdmin,
  ...getBackOfficeGroupAdmin,
  ...getBackOfficeGroupCall,
  ...getBackOfficeGroupCallCenterAdmin,
  ...getBackOfficeGroupCompanionAdmin,
  ...getBackOfficeCareAdmin,
  ...getBackOfficeCareAdminConsult,

  ...getExternalOfficeSftpConsult,

  ...getIndustryOfficeGroupIndustry,
  ...getIndustryOfficeInsightIndustry,
  ...getIndustryOfficeStoreIndustry,
  ...getBackOfficeSchoolAdmin,
  ...getBackOfficeSchoolInterneAdminConsult,
  ...getIndustryOfficeSchoolIndustry,
]

export const allRoutesFront = [
  ...getFrontOfficeGroupPharmacien,
  ...getFrontOfficeGroupPharmacienAndUserTeam,

  ...getFrontOfficeSoundPharmacien,
  ...getFrontOfficeStorePharmacien,
  ...getFrontOfficeStoreBagPharmacien,

  ...getFrontOfficeSchoolManagerLearner,
  ...getFrontOfficeSchoolPharmacienAndUserTeam,
  ...getFrontOfficeSchoolUserTeam,

  ...getFrontOfficeInsightPharmacien,
  ...getFrontOfficeInsightRewardsUser,
  ...getFrontOfficeInsightPharmacienAndUserTeam,
  ...getFrontOfficeInsightUserChallenge,

  ...getFrontOfficeConsultContract,

  ...getFrontOfficeCarePharmacien,
  ...getFrontOfficeCareActivation,

  ...getFrontOfficeInsightHoldOwner,
  ...getFrontOfficeSoundHoldOwner,
  ...getFrontOfficeStoreBagHoldOwner,

  // Connexion par QR code (flux A) : accessible à tout utilisateur authentifié, tous rôles.
  ...getFrontOfficeQrLoginAllUser,
  // Actualité pharmacie du compte comptoir : route utilitaire, hors menu, lecture seule.
  ...routeFrontOfficeGroupNewsCounter,
  // Espace d'un compte URPS : les pharmacies de son territoire.
  ...getFrontOfficeGroupUrps,
]

export const allRoutesFrontGroupementChain = [
  // Pages communes de l'espace (entite Group) EN PREMIER : elles portent la section
  // « Mon groupement » du menu pour tout membre, delegues compris.
  ...getFrontOfficeGroupGroupementChainListRoutesAllUser,
  ...getFrontOfficeSoundGroupementChainListRoutesAllUser,
  ...getFrontOfficeSchoolGroupementChainListRoutesAllUser,
  ...getFrontOfficeSchoolGroupementChainListRoutesManager,
  // Module Store de l'espace groupement (« Ma centrale ») : section derivee de l'entite.
  ...getFrontOfficeStoreGroupementChainListRoutesAllUser,
]

export const allRoutesApplication = [
  ...allRoutesAdmin,
  ...allRoutesFront,
  ...allRoutesFrontGroupementChain,
]

export const routeNotAuthenticate = [
  {
    route: 'Login',
    text: 'Login',
    href: '/login',
    logo: null,
    home: false,
    menuHeader: false,
  },
  {
    route: 'Register',
    text: 'Register',
    href: '/register',
  },
  {
    route: 'ProSanteConnectCallback',
    text: 'Pro Sante Connect',
    href: '/auth/pro-sante-connect',
  },
  {
    route: 'EndOfSurveyPublic',
    text: 'Fin enquete',
    href: '/public/end-survey',
  },
  {
    route: 'LegalDocumentPublic',
    text: 'Documents légaux',
    href: '/public/legal/[type]',
  },
  {
    route: 'Contact',
    text: 'Contact',
    href: '/contact',
  },
  // Flux B (« push ») de la connexion par QR code : page vue quand l'appareil photo scanne
  // le QR du header SANS l'app installée (l'app, elle, intercepte ce lien via App/Universal
  // Links et ne l'affiche jamais). `pharmedigroup-api/docs/QR_LOGIN.md`.
  {
    route: 'QrLoginAppInfo',
    text: 'Connexion par QR code — application mobile',
    href: '/frontoffice/qr-login/app',
    menuHeader: false,
  },
  // Desinscription patient aux campagnes Care. Chemin volontairement tres court : le lien
  // est genere par l'API (`CareCampaignUnsubscribeLinkService`) et voyage dans un SMS de
  // 160 caracteres. Ne pas rallonger sans mesurer le cout en segments.
  {
    route: 'CareCampaignUnsubscribe',
    text: 'Desinscription campagnes',
    href: '/d/[token]',
  },
  // Opposition aux e-mails de programme (Sound / PLV-Sacherie / Insight). Le lien est
  // genere par l'API (`ProgramEmailUnsubscribeLinkService`) et voyage dans le pied des
  // e-mails : le chargement de la page n'ecrit rien, seul le clic vaut opposition.
  {
    route: 'ProgramEmailUnsubscribe',
    text: 'Opposition aux e-mails de programme',
    href: '/public/program-email/[token]',
  },
  // « Je veux le spot » des newsletters Sound. Lien genere par l'API
  // (`SoundPublicSpotOptInLinkService`) : la page lance l'ajout a son chargement, l'appel GET
  // de l'API n'ecrit jamais (pre-ouverture des liens par les antivirus de messagerie).
  {
    route: 'SoundPublicSpotOptIn',
    text: 'Ajout d’un spot public',
    href: '/public/sound/spot/[token]',
  },
]
